<template>
  <page-header-wrapper>
    <div style="background-color: white; padding: 2%;display: flex;width: 100%">
      <a-card :bordered="false" style="background-color:rgb(236,246,255);width: 16%;border-radius: 5%;margin:0.5%">
        <p><font style="font-size: 20px">{{ $t('reportForms.totalUser') }}</font></p>
        <p><font style="font-size: 20px;font-weight: bold">{{ this.userData.userTotalNum }}</font></p>
      </a-card>

      <a-card :bordered="false" style="background-color:rgb(236,246,255);width: 16%;border-radius: 5%;margin:0.5%">
        <p><font style="font-size: 20px">{{ $t('reportForms.totalPay') }}</font></p>
        <p><font style="font-size: 20px;font-weight: bold">{{ this.userData.consumptionNum }}</font></p>
      </a-card>

      <a-card :bordered="false" style="background-color:rgb(236,246,255);width: 16%;border-radius: 5%;margin:0.5%">
        <p><font style="font-size: 20px">{{ $t('reportForms.noTotalPay') }}</font></p>
        <p><font style="font-size: 20px;font-weight: bold">{{ this.userData.noConsumptionNum }}</font></p>
      </a-card>

      <a-card :bordered="false" style="background-color:rgb(236,246,255);width: 16%;border-radius: 5%;margin:0.5%">
        <p><font style="font-size: 20px">{{ $t('reportForms.vipTotal') }}</font></p>
        <p><font style="font-size: 20px;font-weight: bold">{{ this.userData.subscriptionNum }}</font></p>
      </a-card>

      <!--      <a-card  :bordered="false" style="background-color:rgb(236,246,255);width: 14%;border-radius: 5%;margin: 0.5%">-->
      <!--        <p><font style="font-size: 20px">来源总数</font></p>-->
      <!--        <p><font style="font-size: 20px;font-weight: bold">{{ this.userData.sourceNum }}</font></p>-->
      <!--      </a-card>-->

      <a-card :bordered="false" style="background-color:rgb(236,246,255);width: 16%;border-radius: 5%;margin:0.5%">
        <p><font style="font-size: 20px">{{ $t('reportForms.activeNum') }}</font></p>
        <p><font style="font-size: 20px;font-weight: bold">{{ this.userData.activeNum }}</font></p>
      </a-card>

      <a-card :bordered="false" style="background-color:rgb(236,246,255);width: 16%;border-radius: 5%;margin:0.5%">
        <p><font style="font-size: 20px">{{ $t('reportForms.silentNum') }}</font></p>
        <p><font style="font-size: 20px;font-weight: bold">{{ this.userData.silentNum }}</font></p>
      </a-card>

    </div>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!--            <a-col :md="5" :sm="24">-->
            <!--              <a-form-item label="手机号" prop="mobile">-->
            <!--                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <!--            <a-col :md="5" :sm="24">-->
            <!--              <a-form-item label="邮箱" prop="email">-->
            <!--                <a-input v-model="queryParam.email" placeholder="请输入邮箱" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <a-col :md="4" :sm="24">
              <a-form-item :label="$t('reportForms.mobile')" prop="mobile">
                <a-input v-model="queryParam.mobile" :placeholder="$t('recharge.inputMobile')" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="24">
              <a-form-item :label="$t('reportForms.email')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('recharge.inputEmail')" allow-clear/>
              </a-form-item>
            </a-col>
              <template v-if="advanced">
                <a-col :md="4" :sm="24">
                  <a-form-item :label="$t('reportForms.source')" prop="sex">
                    <a-select :placeholder="$t('reportForms.selectSource')" v-model="queryParam.type">
                      <a-select-option :value="0">Facebook</a-select-option>
                      <a-select-option :value="1">Google</a-select-option>
                      <a-select-option :value="2">Apple</a-select-option>
                      <a-select-option :value="3">Tiktok</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :md="4" :sm="24">
                  <a-form-item :label="$t('reportForms.isVip')" prop="sex">
                    <a-select :placeholder="$t('reportForms.selectIsVip')" v-model="queryParam.isVip">
                      <a-select-option :value="0">{{ $t('common.no') }}</a-select-option>
                      <a-select-option :value="1">{{ $t('common.yes') }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="4" :sm="24">
                  <a-form-item :label="$t('reportForms.showId')" prop="nickname">
                    <a-input v-model="queryParam.showId" :placeholder="$t('reportForms.inputShowId')" allow-clear/>
                  </a-form-item>
                </a-col>

                <a-col :md="4" :sm="24">
                  <a-form-item :label="$t('reportForms.nickname')" prop="nickname">
                    <a-input v-model="queryParam.nickname" :placeholder="$t('reportForms.inputNickname')" allow-clear/>
                  </a-form-item>
                </a-col>

              </template>

            <a-col :md="!advanced && 4 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                                <a @click="toggleAdvanced" style="margin-left: 8px">
                                  {{ advanced ? $t('reportForms.collapse') : $t('reportForms.expand') }}
                                  <a-icon :type="advanced ? 'up' : 'down'"/>
                                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">

        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" style="margin-bottom: 20px"/>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <update-vip-time-form
        ref="updateVipTimeForm"
        @ok="handleVipTimeUpdate"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1300 }"
      >
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>

        <span slot="userStatus" slot-scope="text, record">
          <a-switch
            :checkedChildren="$t('common.yes')"
            :unCheckedChildren="$t('common.no')"
            v-model="record.status == 1"
            @change="changeIsOpen($event,record)"/>
        </span>

        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="vipOverTime" slot-scope="text, record">
          <div v-if="record.isVip == 1">{{ parseTime(record.vipOverTime) }}</div>
          <div v-else>-</div>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" />
          <a v-if="record.isVip == 1" @click="$refs.updateVipTimeForm.audit(record)">
            <a-icon/>{{ $t('reportForms.setVipExpireTime') }}
          </a>
        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, delUser, changeIsOpen, getUserTotalData } from '@/api/biz/userForm'
import { tableMixin } from '@/store/table-mixin'
import UpdateVipTimeForm from './modules/UpdateVipTimeForm'

export default {
  name: 'User',
  components: {
    UpdateVipTimeForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      userData: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {},
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          customRender: (text, record, index) => index + 1,
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('reportForms.userId'),
          dataIndex: 'id',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('reportForms.showId'),
          dataIndex: 'showId',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('reportForms.nickname'),
          dataIndex: 'nickname',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('reportForms.source'),
          dataIndex: 'type',
          width: 120,
          align: 'center',
          customRender: (t) => {
            if (t == 0) {
              return this.$t('reportForms.emailSource')
            } else if (t == 1) {
              return this.$t('reportForms.mobileSource')
            } else if (t == 3) {
              return this.$t('reportForms.thirdPartyLogin')
            }
          }
        },
        {
          title: this.$t('reportForms.mobile'),
          dataIndex: 'mobile',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('reportForms.areaCode'),
          dataIndex: 'areaCode',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('reportForms.email'),
          dataIndex: 'email',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('reportForms.address'),
          dataIndex: 'address',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('reportForms.isVip'),
          dataIndex: 'isVip',
          width: 100,
          align: 'center',
          customRender: (isVip) => {
            if (isVip == 0) {
              return this.$t('common.no')
            } else if (isVip == 1) {
              return this.$t('common.yes')
            }
          }
        },
        {
          title: this.$t('reportForms.type'),
          dataIndex: 'vipType',
          width: 120,
          align: 'center',
          customRender: (t, r) => {
            if(r.isVip == 1) {
              if(t == 1) {
                return this.$t('reportForms.weekVip')
              }else if(t == 2) {
                return this.$t('reportForms.monthVip')
              }else if(t == 3) {
                return this.$t('reportForms.yearVip')
              }
            } else {
              return  '-'
            }
          }
        },
        {
          title: this.$t('reportForms.vipExpireTime'),
          dataIndex: 'vipOverTime',
          width: 160,
          scopedSlots: { customRender: 'vipOverTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('reportForms.totalRecharge'),
          dataIndex: 'totalPay',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('reportForms.diamondBalance'),
          dataIndex: 'diamond',
          width: 120,
          align: 'center'
        },
        {
          title: this.$t('reportForms.activity'),
          dataIndex: 'isActive',
          width: 100,
          align: 'center',
          customRender: (t) => {
            if (t == 0) {
              return this.$t('reportForms.active')
            } else {
              return this.$t('reportForms.silent')
            }
          }
        },
        {
          title: this.$t('recharge.status'),
          dataIndex: 'status',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'userStatus' }
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created() {
    this.getList()
    this.getUserTotalData()
  },
  watch: {},
  methods: {
    /** 查询用户信息列表 */
    getList() {
      this.loading = true
      pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getUserTotalData() {
      getUserTotalData().then(response => {
        this.userData = response.data
      })
    },
    /** 处理会员到期时间更新后的刷新 */
    handleVipTimeUpdate() {
      this.getList()
      this.getUserTotalData()
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickname: undefined,
        isVip: undefined,
        invitationCode: undefined,
        showId: undefined,
        type: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    changeIsOpen(e, record) {
      record.status = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          this.$t('reportForms.operationSuccess')
        )
        return record.status = e ? 1 : 0
      })
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('reportForms.confirmDelete'),
        content: this.$t('reportForms.confirmDeleteContent') + ids,
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('reportForms.deleteSuccess'),
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('reportForms.confirmExport'),
        content: this.$t('reportForms.confirmExportContent'),
        onOk() {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `${that.$t('reportForms.userInfoExportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
